export enum RemoteControlReason {
  COLD = 'COLD',
  HOT = 'HOT',
  MAINTENANCE = 'MAINTENANCE',
  OUT_SCHEDULE = 'OUT_SCHEDULE',
  OTHER = 'OTHER'
}
